// movementControls.js
"use strict";
document.addEventListener('DOMContentLoaded', function(){
  // Marker toggle setup
  const idMap = {
    1: 'hand-finger-point',
    2: 'hand-thumb-up',
    3: 'hand-thumb-down',
    4: 'hand-fist',
    5: 'hand-open-hand',
    6: 'hand-ok-sign',
    7: 'hand-rock-sign',
    8: 'hand-shaka-sign',
    9: 'hand-point-up',
    10: 'hand-peace-sign',
    11: 'hand-pinch'
  };
  const keys = Object.keys(idMap).map(Number);
  let markerIdx = keys[0];
  function hideAllHands(){
    Object.values(idMap).forEach(id =>
      document.querySelectorAll('#' + id).forEach(el => el.style.display = 'none')
    );
  }
  function showHand(){
    document.querySelectorAll('#' + idMap[markerIdx]).forEach(el => el.style.display = 'inline');
  }
  hideAllHands();
  showHand();

  // Mirror toggle
  let mirrorVisible = true;
  const mirrorEl = document.getElementById('ikSVGMirror');
  function updateMirrorVisibility(){
    mirrorEl.style.display = mirrorVisible ? '' : 'none';
  }
  updateMirrorVisibility();

  // Recorder state
  let recording     = false;
  let playback      = false;
  let recorded      = [];
  let recordStart   = 0;
  let playbackStart = 0;
  let playIndex     = 0;

  // Key events
  window.addEventListener('keydown', function(e){
    if (playback && e.isTrusted) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
    if (recording && e.isTrusted) {
      recorded.push({
        time: performance.now() - recordStart,
        type: 'keydown',
        key: e.key
      });
    }
    const k = e.key.toLowerCase();
    switch (k) {
      case 'r':
        recorded = [];
        recordStart = performance.now();
        recording = true;
        break;
      case 's':
        recording = false;
        break;
      case 'p':
        playback = true;
        playbackStart = performance.now();
        playIndex = 0;
        break;
      case 'q':
        mirrorVisible = !mirrorVisible;
        updateMirrorVisibility();
        break;
      case 'e':
        const idx = keys.indexOf(markerIdx);
        markerIdx = keys[(idx + 1) % keys.length];
        hideAllHands();
        showHand();
        break;
    }
  }, true);

  // Mouse events
  window.addEventListener('mousemove', function(e){
    if (playback && e.isTrusted) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
    if (recording && e.isTrusted) {
      recorded.push({
        time: performance.now() - recordStart,
        type: 'mousemove',
        x: e.clientX,
        y: e.clientY
      });
    }
  }, true);

  // Playback loop
  requestAnimationFrame(function loop(ts){
    if (playback) {
      const elapsed = ts - playbackStart;
      while (playIndex < recorded.length && recorded[playIndex].time <= elapsed) {
        const ev = recorded[playIndex++];
        if (ev.type === 'mousemove') {
          window.dispatchEvent(new MouseEvent('mousemove', {
            clientX: ev.x,
            clientY: ev.y,
            bubbles: true
          }));
        } else if (ev.type === 'keydown') {
          window.dispatchEvent(new KeyboardEvent('keydown', {
            key: ev.key,
            bubbles: true
          }));
        }
      }
      if (playIndex >= recorded.length) {
        playback = false;
      }
    }
    requestAnimationFrame(loop);
  });
});
